module.exports = __webpack_public_path__ + "static/media/big-active-karma.3e025eed.svg";